import React from 'react';
import PageLoader from './PageLoader';
import './PageLoader.css';

function PageLoadingArea({ isLoading, children }) {
  return (
    <div className="page-loading-area">
      {isLoading && <PageLoader />}
      {children}
    </div>
  );
}

export default PageLoadingArea;
